import Page, { getServerSideProps as compGetServerSideProps } from 'components/pages/Blog';

export const getServerSideProps = compGetServerSideProps;
export default Page;
